<template>
  <div
    class="base-radio-button font-bold-16px"
    @click="triggerChange"
    :class="{ selected: shouldBeChecked }"
  >
    <svg
      v-if="shouldBeChecked"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="base-radio-button-mark"
    >
      <path
        d="M15.9361 10.0156L11.533 15.037L8.03027 12.0001"
        stroke="#008C95"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        stroke="#008C95"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="base-radio-button-mark"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        stroke="#DADBDC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <div class="base-radio-button-label">
    {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseRadioButton",
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    value: {
      type: [Boolean, Number, String, Object],
      required: true,
    },
    modelValue: {
      type: [Boolean, Number, String, Object],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue == this.value;
    },
  },
  methods: {
    triggerChange() {
      this.$emit("change", this.value);
    },
    updateInput() {
      this.$emit("change", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-radio-button {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dadbdc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: -0.2px;
  transition: background-color 0.25s ease-in, border-color 0.25s ease-in;
}

.base-radio-button.selected {
  background-color: #f5fbfb;
  border-color: #008c95;
}

.base-radio-button:hover {
  background-color: #f5fbfb;
  border-color: #008c95;
}
.base-radio-button-mark{
  margin-right: 10px;
}
.base-radio-button-label{
  font-size:14px;
}
</style>